<template>
    <div class="set-my-info marginL201 clearfix" v-loading="!isSuccess">
        <div class="login-title h50">
            <span></span>
            我的信息
        </div>
        <div class="clearfix set-form-wrap marginT35" v-if="isSuccess">
            <el-form  label-width="120px" class="fl w385">

                <el-form-item label="姓名：" class="form-item">
                    <el-input
                            :value="docInfo.doc.docName"
                            size="small"
                            readonly
                            class="form-input h24 w240"/>
                </el-form-item>
                <el-form-item label="手机号码：" class="form-item">
                    <el-input
                            :value="docInfo.docPrivate.docMobile"
                            size="small"
                            readonly
                            class="form-input h24 w240"/>
                </el-form-item>
                <el-form-item label="身份证号码：" class="form-item">
                    <el-input
                            :value="docInfo.docPrivate.docIdcard"
                            size="small"
                            readonly
                            class="form-input h24 w240"/>
                </el-form-item>
                <el-form-item label="执业机构：" class="form-item">
                    <el-input
                            :value="docInfo.doc.hosName"
                            size="small"
                            readonly
                            class="form-input h24 w240"/>
                </el-form-item>
                <el-form-item label="科室：" class="form-item">
                    <el-input
                            :value="docInfo.doc.deptName"
                            size="small"
                            readonly
                            class="form-input h24 w240"/>
                </el-form-item>
                <el-form-item label="职称：" class="form-item">
                    <el-input
                            :value="docInfo.doc.docTitle"
                            size="small"
                            readonly
                            class="form-input h24 w240"/>
                </el-form-item>
                <el-form-item label="性别：" class="form-item">
                    <el-input
                            :value="docInfo.doc.docGender=='M'?'男':'女'"
                            size="small"
                            readonly
                            class="form-input h24 w240"/>
                </el-form-item>
                <!--<el-button type="primary" class="h36 w140 save-btn" @click="modifyMyInfo" :loading="isSuccess">保存</el-button>-->
            </el-form>
        </div>
    </div>
</template>
<script>
    import axiosUtil from "../../utils/AxiosUtils.js"
    import { Loading } from "element-ui";
    import Vue from "vue";
    Vue.use(Loading);
    export default{
        data: function(){
            return{
                docInfo: {},//医生详细信息
                isSuccess: false,//是否加载成功
            }
        },
        created: function () {
            this.getConsultDetail();
        },
        methods:{
            getConsultDetail: function(){//获取医生详细信息
                let _this = this;
                _this.isSuccess = false;
                let options = {
                    // docId: JSON.parse(sessionStorage.getItem("loginInfo")).docId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.user.doc.get"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = true;
                    _this.docInfo = data.obj;
                }, function () {
                    _this.isSuccess = true;
                });
            },
        }
    }
</script>
